export default __webpack_public_path__ + "static/media/USDC.0ab341ae.svg";